export enum FontFamilyOptionType {
  ONE = 'one',
  TWO = 'two',
  ONLY_FONT = 'only-font',
}
